import styled from 'styled-components';
import { media, Button } from '@simplywallst/ui-core';

export const SectionAuthTitle = styled('div')`
  margin-bottom: ${({ theme }) => theme.x2spacePx + 'px'};
`;

export const HorizontalButtonGroup = styled('div')`
  display: flex;
  gap: 6px;

  > div {
    flex-grow: 1;
    flex-basis: 0;
    min-width: 0;
    text-align: center;

    > button {
      display: block;
    }
  }
`;

export const ButtonContainer = styled('div')`
  position: relative;
  padding: ${(props) => props.theme.x2space * 0.25}rem 0;
  ${media.smDown`
    padding: ${(props) => props.theme.x2space * 0.25}rem 0;
  `}
`;

export const UseLocal = styled('p')`
  margin-top: ${(props) => props.theme.x2spacePx}px;
  text-align: center;
`;

export const SignInLink = styled(Button)`
  box-shadow: none;
`;
